import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import "./style.sass";
import { useIsMobile } from 'hooks/useIsMobile';
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import { useForm } from 'react-hook-form';
import {ModalLoadingCredit} from 'components/Loading';
import { SolicitudProceso } from '../SolicitudProceso/SolicitudProceso';
import { decodeStorage, encodeStorage } from 'functions/storageBase64';
import { postClaroScore } from 'services/claroScore';
import { PantallaError } from '../MensajesErrores/pantallaError';
import incode from "../Incode/config/incode";
import { ModalError } from 'components/Error/ErrorModal';
import { PantallaError500 } from '../MensajesErrores/pantallaError500';
import { useVerificarCredito } from 'hooks/useVerificacionCredito';

export function BloqueBeneficios({ beneficio, subBeneficio }) {
    return (
        <li className="liBeneficios">
            <div className="boxIcon">
                <div className="icon"> </div>
            </div>
            <div className="copy">
                <p>{beneficio} {subBeneficio && <span className='copyBeneficiosub fontsize14'><br></br>{subBeneficio}</span>}</p>
            </div>
        </li>
    )
}

export function AntesDeComenzar() {

    //obtiene el parametro externo de la url EXTERNO para no mostrar header
    const searchParams = new URLSearchParams(document.location.search)
    const EXTERNO = searchParams.get('externo')
    console.log('EXTERNO', EXTERNO)
    encodeStorage('EXTERNO',EXTERNO)

    //verificar credito
    const { cardending, cardendingRes } = useVerificarCredito(true);

    const history = useHistory();
    const { isMobile } = useIsMobile();
    const [ loading, setLoading ] = useState(false);

    const [postEnviarClaroScoreRes, setPostEnviarClaroScoreRes] = useState(false);
    const profileData = decodeStorage('profileData');
    const [tipoDeRespuestaCredito, setTipoDeRespuestaCredito] = useState(0);

    const [objRespuestaCS, setObjRespuestaCS] = useState(false);

    //variables para modal de error
    const [errorCode, setErrorCode] = useState();
    const [messageResponse, setMessageResponse] = useState();
    const [sectionActive, setSectionActive] = useState("");
    const [showModalErr, setShowModalErr] = useState(false);

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Before Start  Credit-Page');
        window.ineum('meta', 'portal', 'Credito CS');
        window.scrollTo(0, 0);
    }, [])

    // valida respuesta del servicio y si no pasa manda el error
    const handleCloseErr = () => {
        setShowModalErr(false);
        if (sectionActive === 'verificar') {
            window.location.href = `${BASE_PATH}`;
        }
    }

    const [permisos, setPermisos] = useState(false);

    const { register, handleSubmit, errors } = useForm({
        defaultValues: {
            permisos: false
        }
    });

    const sendFormInformacionFinanciera = data => {
        console.log(data);
        history.push(`${BASE_PATH}${SUB_DIRECTORY}linea-telmex`);
    };

    const valPermisos = {
        required: 'Campo obligatorio',
    };

    const seleccionarPermisos = (e) => {
        setPermisos(e.target.value);
    };

     //consulta claro score
     useEffect(() => {
        //no tiene credito
        if(cardendingRes === true && !cardending){
            setLoading(true);
            postClaroScore({         
                "externalId": `${profileData?.idClaro}`,
                "nombre": profileData?.nombre,
                "apellido_paterno": profileData?.apellidoP,
                "apellido_materno":  profileData?.apellidoM,
                "email": profileData?.correo,
                "telefono": "0",
                "TipoValidacion": 1    
            })
            .then(setPostEnviarClaroScoreRes)
        }
        //tiene credito
        else if(cardendingRes === true && cardending){
            history.push(`${BASE_PATH}${SUB_DIRECTORY}home`)
        }
    }, [cardendingRes])

    //verifica si es movil si no lo manda aQR
    useEffect(() => {
        if (incode.isDesktop()) {
            history.push(`${BASE_PATH}${SUB_DIRECTORY}comenzar-solicitud`);
        }
    }, [])

    useEffect(() => {
        if (postEnviarClaroScoreRes) {
            console.log("respuesta claro score",postEnviarClaroScoreRes)
            if(postEnviarClaroScoreRes?.statusCode === 200){
                setLoading(false); 
                //tiene credito? "No" pasa a hacer el credito
                if(postEnviarClaroScoreRes?.data?.tieneCredito === "Si"){
                    //Pertenece a lista negra o validacion si excedio el numero de intentos (suspencion temporal)
                    if(postEnviarClaroScoreRes?.data?.tipo === 2 || postEnviarClaroScoreRes?.data?.tipo === 1){
                        setObjRespuestaCS(postEnviarClaroScoreRes?.data)    
                        setTipoDeRespuestaCredito(2);
                    }
                    //Solicitud en espera de respuesta
                    else if(postEnviarClaroScoreRes?.data?.tipo === 0){
                        setObjRespuestaCS(postEnviarClaroScoreRes?.data)
                        setTipoDeRespuestaCredito(1);
                    }
                }
                //validacion si excedio el numero de intentos (suspencion temporal) y tiene credito en no
                else if(postEnviarClaroScoreRes?.data?.tieneCredito === "No" && postEnviarClaroScoreRes?.data?.tipo === 1 && postEnviarClaroScoreRes?.data?.respuestaCScore === "false" ){
                    // para no poner el texto "lo sentimos" en pantalla error le aplicamos un "Si" a tiene credito
                    // console.log("pasa por aca");
                    let obj = postEnviarClaroScoreRes?.data;
                    obj.tieneCredito = "Si";
                    setObjRespuestaCS(postEnviarClaroScoreRes?.data)    
                    setTipoDeRespuestaCredito(2);
                } 
                else if(postEnviarClaroScoreRes?.data?.tieneCredito === "No"){
                    console.log("Sigue en el proceso");
                }
                else{
                    setShowModalErr(true);
                    setErrorCode(postEnviarClaroScoreRes?.statusCode);
                    setSectionActive('verificar');
                    setMessageResponse("Variable tieneCredito vacía o inexistente");
                    setLoading(false);
                }
            }else if(postEnviarClaroScoreRes?.statusCode > 200 && postEnviarClaroScoreRes?.statusCode < 500){
                setShowModalErr(true);
                setErrorCode(postEnviarClaroScoreRes?.statusCode);
                setSectionActive('verificar');
                setMessageResponse(
                    postEnviarClaroScoreRes?.data?.codMen ?  
                        postEnviarClaroScoreRes?.data?.codMen :
                            postEnviarClaroScoreRes?.data?.sMensaje
                );
                setLoading(false);
            }
            else{
                setErrorCode(postEnviarClaroScoreRes?.statusCode);
                setLoading(false);
            }

        }
    }, [postEnviarClaroScoreRes])


    return (
        <>
            {!cardendingRes && <ModalLoadingCredit />}
            { loading && <ModalLoadingCredit /> }
            {errorCode >= 500
                ? <PantallaError500 />
                : tipoDeRespuestaCredito === 0 && 
                    <div className="homeMobile">
                        {
                            EXTERNO ? null : <HeaderMobileCredito title={"Solicitud de crédito ClaroShop"} type="backFull" />
                        }
                        <main className='nuevoCredito'>
                            <form onSubmit={handleSubmit(sendFormInformacionFinanciera)}>
                                <section className="sectionPrincipalBeneficios">
                                    <div className="contenido">
                                        <div className="contenedorLandingBeneficios">

                                            <div className='marginTop10'>
                                                
                                                <div className='top subt'>
                                                    <h1 className='bold fontsize22'>¡Bienvenido {profileData?.nombre}, agradecemos tu preferencia!</h1>
                                                </div>

                                                <p className='ptop20 tLeft top'>Para relizar tu solicitud de Crédito necesitamos validar tu identidad, por favor considera lo siguiente:</p>

                                                {/* seccion beneficios */}
                                                <div className='boxUl  marginBottom20 ptop20'>
                                                    <ul className="ulBeneficios">
                                                        <BloqueBeneficios beneficio={'Ten a la mano tu identificación oficial vigente (INE o IFE, Pasaporte o FM2)'} key={1} />
                                                        <BloqueBeneficios beneficio={'Celular con cámara.'} key={2} />
                                                        <BloqueBeneficios beneficio={'Ubicate en un lugar con buena iluminación.'} key={3} />
                                                        <BloqueBeneficios beneficio={'Disponibilidad para tomarte una selfie.'} subBeneficio={'La necesitamos para asegurarnos que eres la misma persona que indica tu documento elegido.'} key={4} />
                                                    </ul>

                                                </div>                                                               

                                            </div>
                                        </div>
                                    </div>
                                </section>
                                <div className="secFinanciero">
                                    <div className="campo">
                                        <ul onChange={seleccionarPermisos}>
                                            <li className="liAutorizacion">
                                                <input className="radio" id="permisos" type="checkbox" value="SI" name="permisos" ref={register(valPermisos)} />
                                                <label name="permisos" htmlFor="permisos" className="copyAviso">Acepto los Términos y Condiciones del <a className="linkSub" href={`${BASE_PATH}contrato-credito/`} target="_blank" rel="noopener noreferrer">Contrato de Crédito</a> que Claroshop.com pone a mi disposición</label>
                                            </li>
                                        </ul>
                                        {permisos === false && errors.permisos && errors.permisos.message
                                            ? <div className="error">Campo obligatorio</div>
                                            : null
                                        }
                                    </div>
                                </div>
                                <div className="boxBtnSolicitar marginBottom30">
                                    <button className="btnSolicitar">Comenzar</button>
                                </div>
                            </form>
                        </main>
                    </div>
            }

            {tipoDeRespuestaCredito === 1 && <SolicitudProceso objRespuesta={objRespuestaCS} />}

            {tipoDeRespuestaCredito === 2 && <PantallaError objError={objRespuestaCS} />}

            {showModalErr &&
                <ModalError
                    errorCode={errorCode}
                    section={sectionActive}
                    message={messageResponse}
                    handleClose={handleCloseErr}
                />
            }

        </>
    )
}